const styles = (theme) => ({
  sellerText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
})

export default styles
